<template>
  <main-container>
    <a-card :bordered="false">
      <template slot="title">
        <div class="DataFilter">
          <YMpicker
            @change="
              range = $event;
              loadYmdStatistic();
            "
          />
        </div>
      </template>
      <a-row :gutter="16">
        <a-col :span="6">
          <a-card :bordered="false" style="background: #ffd344">
            <div class="card_title">今日</div>
            <div class="card_content" @click="goDetail('d')">
              <a-statistic title="订单量" :value="ymdStatistic.day.count" />
              <a-statistic title="订单金额" :value="ymdStatistic.day.amount" />
              <a-statistic title="收入" :value="ymdStatistic.day.income" />
            </div>
          </a-card>
        </a-col>
        <a-col :span="6">
          <a-card :bordered="false" style="background: #ff7970">
            <div class="card_title">本月</div>
            <div class="card_content" @click="goDetail('m')">
              <a-statistic title="订单量" :value="ymdStatistic.month.count" />
              <a-statistic title="订单金额" :value="ymdStatistic.month.amount" />
              <a-statistic title="收入" :value="ymdStatistic.month.income" />
            </div>
          </a-card>
        </a-col>
        <a-col :span="6">
          <a-card :bordered="false" style="background: #5273FE">
            <div class="card_title">本年</div>
            <div class="card_content" @click="goDetail('y')">
              <a-statistic title="订单量" :value="ymdStatistic.year.count" />
              <a-statistic title="订单金额" :value="ymdStatistic.year.amount" />
              <a-statistic title="收入" :value="ymdStatistic.year.income" />
            </div>
          </a-card>
        </a-col>
        <a-col :span="6">
          <a-card :bordered="false" style="background: #44C3A0">
            <div class="card_content" style="height: 92px;">
              <a-icon type="contacts" style="font-size: 80px;color: #fff;" />
            </div>
          </a-card>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="数量记录" :bordered="false" style="margin-top: 24px">
      <a-row :gutter="16">
        <a-col :span="8">
          <a-card :bordered="false">
            <div class="card_num_content">
              <div style="background: #f4c735" class="icon_bg">
                <a-icon type="property-safety" style="font-size: 30px;color:#fff" />
              </div>
              <a-statistic :title="statisticData.total_count" value="订单总数量" />
            </div>
          </a-card>
        </a-col>
        <a-col :span="8">
          <a-card :bordered="false">
            <div class="card_num_content">
              <div style="background: #f44235" class="icon_bg">
                <a-icon type="money-collect" style="font-size: 30px;color:#fff" />
              </div>
              <a-statistic :title="statisticData.total_amount | toLocaleString" value="总下单金额" />
            </div>
          </a-card>
        </a-col>
        <a-col :span="8">
          <a-card :bordered="false">
            <div class="card_num_content" style="border-right: none">
              <div style="background: #05abed" class="icon_bg">
                <a-icon type="user" style="font-size: 30px;color:#fff" />
              </div>
              <a-statistic :title="statisticData.total_user" value="总用户数" />
            </div>
          </a-card>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="营收统计" :bordered="false" style="margin-top: 24px">
      <a-row :gutter="16" style="margin: 10px 0 40px">
        <a-col :span="6" :offset="2">
          <h4>{{ type == 'month' ? '本月' : '本周' }}总订单数：{{ total_order }}</h4>
        </a-col>
        <a-col :span="6">
          <h4>{{ type == 'month' ? '本月' : '本周' }}总订总金额单数：€ {{ total_price }}</h4>
        </a-col>
        <a-col :span="10" style="text-align: right">
          <a-button-group>
            <a-button
              v-for="(item, index) in typeList"
              @click="type = item.id"
              :type="type == item.id ? 'primary' : ''"
              :key="index"
            >
              {{ item.label }}
            </a-button>
          </a-button-group>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="24">
          <div id="c1"></div>
        </a-col>
      </a-row>
    </a-card>
  </main-container>
</template>

<script>
import { Chart } from '@antv/g2';

import Home from '@/api/home';

import YMpicker from './YearMonthPicker.vue';

export default {
  name: 'Dashboard',
  components: {
    YMpicker,
  },
  data() {
    return {
      statisticData: {
        today_order_count: '', // 今日订单数量
        today_order_amount: '', //今日订单金额
        total_count: '', //订单总数量
        total_amount: '', //总下单金额
        total_user: '', //总用户数
      },
      range: {
        year: '',
        month: '',
      },
      ymdStatistic: {
        day: {
          amount: '',
          count: '',
          income: '',
        },
        month: {
          amount: '',
          count: '',
          income: '',
        },
        year: {
          amount: '',
          count: '',
          income: '',
        },
      },
      obtainOrdeData: [], // 营收统计
      total_order: 0,
      total_price: 0,
      chart: null,

      type: 'month',

      typeList: [
        { id: 'week', label: '本周' },
        { id: 'month', label: '本月' },
        { id: 'last_month', label: '上月' },
        { id: '3month', label: '最近三个月' },
        { id: 'year', label: '今年' },
        { id: 'last_year', label: '去年' },
      ],
    };
  },

  created() {
    this.loadHomeStatistic();
    this.loadObtainOrde();
  },

  mounted() {
    // Step 1: 创建 Chart 对象
    this.chart = new Chart({
      container: 'c1', // 指定图表容器 ID
      autoFit: true,
      height: 400, // 指定图表高度
    });

    // G2中宽度自适应问题
    const e = document.createEvent('Event');
    e.initEvent('resize', true, true);
    window.dispatchEvent(e);
  },

  watch: {
    type(oldVal, newVal) {
      if (oldVal != newVal) {
        this.loadObtainOrde();
      }
    },
  },
  methods: {
    loadYmdStatistic() {
      // 今日
      Home.chat().then(res => {
        this.ymdStatistic.day = {
          amount: res.data.total_price,
          count: res.data.total_order,
          income: res.data.total_income,
        };
      });
      // 本月
      Home.chat({ year: this.range.year, month: this.range.month }).then(res => {
        this.ymdStatistic.month = {
          amount: res.data.total_price,
          count: res.data.total_order,
          income: res.data.total_income,
        };
      });
      // 本年
      Home.chat({ year: this.range.year }).then(res => {
        this.ymdStatistic.year = {
          amount: res.data.total_price,
          count: res.data.total_order,
          income: res.data.total_income,
        };
      });
    },
    loadHomeStatistic() {
      Home.i_lis({}).then(({ data }) => {
        this.statisticData = data;
      });
    },
    loadObtainOrde() {
      Home.obtainOrde({
        type: this.type,
      }).then(({ data }) => {
        this.obtainOrdeData = data.list || [];
        this.total_order = data.total_order;
        this.total_price = data.total_price;
        this.chart.data(this.obtainOrdeData);
        this.chart.scale({
          money: {
            alias: '营收',
          },
        });
        this.chart.axis('money', {
          label: {
            formatter: val => {
              return val + ' €';
            },
          },
        });
        this.chart.line().position('date*money');
        this.chart.point().position('date*money');
        this.chart.render();
      });
    },
    goDetail(type) {
      var param;
      switch (type) {
        case 'y':
          param = { year: this.range.year };
          break;
        case 'm':
          param = { year: this.range.year, month: this.range.month };
          break;
        case 'd':
          param = {};
          break;
      }
      this.$router.push({ name: this.$routeName.orderAmmount, query: { param: JSON.stringify(param), range: type } });
    },
  },

  filters: {
    toLocaleString(val) {
      return val.toLocaleString();
    },
  },
};
</script>

<style scoped lang="less">
.card_title {
  color: #fff;
  font-weight: bolder;
  margin-bottom: 10px;
}
.card_content {
  display: flex;
  align-items: center;
  padding: 0 1em;
  .ant-statistic {
    flex: 1;
    /deep/.ant-statistic-title {
      color: #fff;
    }
    /deep/.ant-statistic-content {
      color: #fff;
    }
  }
}

.card_num_content {
  display: flex;
  align-items: center;
  border-right: 1px solid #eee;
  justify-content: center;

  .ant-statistic {
    margin-left: 50px;
    /deep/.ant-statistic-title {
      font-size: 19px;
      color: #000;
      text-align: center;
    }
    /deep/.ant-statistic-content {
      color: #000;
      font-size: 14px;
      text-align: center;
    }
  }
}

.icon_bg {
  width: 60px;
  height: 60px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
